<template>
  <div class="PuestosListado">
    <md-layout md-flex="100" md-align="center" class="m-t-24">
      <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="100" md-flex-large="75" md-flex-xlarge="50">
        <md-table-card class="w-100">
          <md-toolbar>
            <h1 class="md-title">Puestos registrados</h1>
          </md-toolbar>
          <md-table>
            <md-table-header>
              <md-table-row>
                <md-table-head>Puesto</md-table-head>
                <md-table-head>Depto.</md-table-head>
                <md-table-head>Descripción</md-table-head>
                <md-table-head>Estatus</md-table-head>
                <md-table-head>Acciones</md-table-head>
              </md-table-row>
            </md-table-header>
            <md-table-body>
              <md-table-row v-for="puesto in puestos" :key="puesto">
                <md-table-cell>{{puesto.nombre_pue}}</md-table-cell>
                <md-table-cell>{{puesto.depto_pue.toUpperCase()}}</md-table-cell>
                <md-table-cell>{{puesto.descripcion_pue}}</md-table-cell>
                <md-table-cell>{{puesto.estatus_pue.toUpperCase()}}</md-table-cell>
                <md-table-cell>
                  <md-button class="md-icon-button" @click.native="modalEditarPuesto(puesto)">
                    <md-icon>edit</md-icon>
                    <md-tooltip md-direction="left">Editar puesto</md-tooltip>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table-body>
          </md-table>
        </md-table-card>
      </md-layout>
    </md-layout>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalEditarPuesto">
      <md-dialog-title>{{puesto.nombre_pue}}</md-dialog-title>
      <md-dialog-content>
        <md-input-container v-bind:class="{ 'md-input-invalid': val.v_nombre }">
          <label>Puesto</label>
          <md-input v-model="puesto.nombre_pue" required></md-input>
        </md-input-container>
        <md-input-container v-bind:class="{ 'md-input-invalid': val.v_descripcion }">
          <label>Descripción</label>
          <md-input v-model="puesto.descripcion_pue" required></md-input>
        </md-input-container>
        <md-input-container v-bind:class="{ 'md-input-invalid': val.v_depto }">
          <label for="depto_pue">Departamento</label>
          <md-select name="depto_pue" id="depto_pue" v-model="puesto.depto_pue" required>
            <md-option value="administrativo">Administrativo</md-option>
            <md-option value="operativo">Operativo</md-option>
            <md-option value="otro">Otro</md-option>
          </md-select>
        </md-input-container>
        <md-input-container v-bind:class="{ 'md-input-invalid': val.v_estatus }">
          <label for="estatus_pue">Estatus</label>
          <md-select name="estatus_pue" id="estatus_pue" v-model="puesto.estatus_pue" required>
            <md-option value="activo">Activo</md-option>
            <md-option value="inactivo">Inactivo</md-option>
          </md-select>
        </md-input-container>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModalEditarPuesto()">Cancelar</md-button>
        <md-button @click.native="guardarCambiosPuesto()" class="md-primary md-raised">Guardar cambios</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
import $ from "jquery";
import dt from "datatables.net";
export default {
  name: "PuestosListado",
  methods: {
    obtenerConceptos() {
      this.$http
        .post("puestos", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "puestos" in response.body) {
              this.puestos = response.body.puestos;
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    modalEditarPuesto(puesto) {
      this.puesto = puesto;
      this.$refs["modalEditarPuesto"].open();
    },
    cerrarModalEditarPuesto() {
      this.puesto = null;
      this.$refs["modalEditarPuesto"].close();
    },
    guardarCambiosPuesto() {
      if (this.validarCamposPuesto()) {
        this.$http
          .post("puestos/actualizar", {
            id: this.puesto.puesto,
            data: this.puesto,
            token: this.$session.get("token")
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                Snackbar.show({
                  text: response.body.msg,
                  actionText: "Cerrar",
                  pos: "top-right",
                  showAction: false
                });
                this.cerrarModalEditarPuesto();
              } else {
                Snackbar.show({
                  text: response.body.error,
                  actionText: "Cerrar",
                  showAction: false,
                  pos: "top-right",
                  backgroundColor: "#F44336",
                  actionTextColor: "#FFF"
                });
              }
            },
            response => {
              Snackbar.show({
                text: "No se pudo establecer conexión con el servidor.",
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right",
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          );
      }
    },
    validarCamposPuesto() {
      !this.puesto.nombre_pue
        ? (this.val.v_nombre = true)
        : (this.val.v_nombre = false);
      !this.puesto.descripcion_pue
        ? (this.val.v_descripcion = true)
        : (this.val.v_descripcion = false);
      !this.puesto.depto_pue
        ? (this.val.v_depto = true)
        : (this.val.v_depto = false);
      !this.puesto.estatus_pue
        ? (this.val.v_estatus = true)
        : (this.val.v_estatus = false);
      if (
        this.val.v_nombre ||
        this.val.v_descripcion ||
        this.val.v_depto ||
        this.val.v_estatus
      ) {
        Snackbar.show({
          text: "Por favor llene todos los campos marcados con *",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  beforeMount() {
    this.obtenerConceptos();
  },
  updated() {
    $(".md-table table").DataTable();
  },
  data() {
    return {
      puestos: [],
      puesto: {
        nombre_pue: null,
        descripcion_pue: null,
        depto_pue: null,
        estatus_pue: null
      },
      val: {
        v_nombre: null,
        v_descripcion: null,
        v_depto: null,
        v_estatus: null
      }
    };
  }
};
</script>


// WEBPACK FOOTER //
// PuestosListado.vue?009ece59